import type { MeasureRegionsPayload } from '@/modules/Editor/MeasureOverlayData'

export const isDefaultMeasureRegion = (measureRegion: MeasureRegionsPayload): boolean =>
  measureRegion.unit.x === 'px' &&
  measureRegion.unit.y === 'px' &&
  measureRegion.x === 0 &&
  measureRegion.y === 0
